// (function () {
//   var timerEl  = document.getElementById('delivery-timer');
//   var bannerEl = document.getElementById('delivery-countdown');

//   // ── Config — read from data attributes, fall back to 13:00 ──
//   var CUTOFF_HOUR = parseInt(timerEl.dataset.cutoffHour, 10);
//   var CUTOFF_MIN  = parseInt(timerEl.dataset.cutoffMin,  10);

//   if (isNaN(CUTOFF_HOUR)) CUTOFF_HOUR = 13;
//   if (isNaN(CUTOFF_MIN))  CUTOFF_MIN  = 0;
//   // ─────────────────────────────────────────────────────────────

//   function pad(n) {
//     return n < 10 ? '0' + n : '' + n;
//   }

//   function tick() {
//     var now    = new Date();
//     var cutoff = new Date(now);
//     cutoff.setHours(CUTOFF_HOUR, CUTOFF_MIN, 0, 0);

//     var diff = cutoff - now;

//     if (diff <= 0) {
//       bannerEl.classList.add('is-hidden');
//       return;
//     }

//     var totalSec = Math.floor(diff / 1000);
//     var h = Math.floor(totalSec / 3600);
//     var m = Math.floor((totalSec % 3600) / 60);
//     var s = totalSec % 60;

//     timerEl.textContent = h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
//   }

//   tick();
//   setInterval(tick, 1000);
// })();

(function () {
  var timerEl  = document.getElementById('delivery-timer');
  var bannerEl = document.getElementById('delivery-countdown');

  // ── Config — read from data attributes, fall back to 13:00 ──
  var CUTOFF_HOUR = parseInt(timerEl.dataset.cutoffHour, 10);
  var CUTOFF_MIN  = parseInt(timerEl.dataset.cutoffMin,  10);

  if (isNaN(CUTOFF_HOUR)) CUTOFF_HOUR = 13;
  if (isNaN(CUTOFF_MIN))  CUTOFF_MIN  = 0;

  var TIMEZONE = 'Europe/Dublin';
  // ─────────────────────────────────────────────────────────────

  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  // Get the current date/time *as it is in Ireland*, regardless of
  // where the visitor's browser thinks it is.
  var irelandFormatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: TIMEZONE,
    hourCycle: 'h23', // avoids the "24:00 at midnight" quirk some engines have
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  function getIrelandParts(date) {
    var parts = irelandFormatter.formatToParts(date);
    var obj = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== 'literal') obj[parts[i].type] = parseInt(parts[i].value, 10);
    }
    return obj;
  }

  function tick() {
    var now = new Date();
    var ir  = getIrelandParts(now);

    // Represent "now in Ireland" and "cutoff in Ireland" using the same
    // fake-UTC trick, so the diff is correct no matter the visitor's own timezone.
    var nowAsUTC    = Date.UTC(ir.year, ir.month - 1, ir.day, ir.hour, ir.minute, ir.second);
    var cutoffAsUTC = Date.UTC(ir.year, ir.month - 1, ir.day, CUTOFF_HOUR, CUTOFF_MIN, 0);

    var diff = cutoffAsUTC - nowAsUTC;

    if (diff <= 0) {
      bannerEl.classList.add('is-hidden');
      return;
    }

    var totalSec = Math.floor(diff / 1000);
    var h = Math.floor(totalSec / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;

    timerEl.textContent = h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
  }

  tick();
  setInterval(tick, 1000);
})();